import React from 'react';
import { useTranslation } from '@wix/yoshi-flow-editor';
import Button from '../button';
import EmptyStates from '../empty-states';
import Link from '../link/internal-link';

const NotFound: React.FC = () => {
  const { t } = useTranslation();
  return (
    <EmptyStates
      title={t('not-found.nothings-showing-up')}
      content={t('not-found.head-back')}
      controls={
        <Button component={Link} to="/">
          {t('not-found.back')}{' '}
        </Button>
      }
    />
  );
};

export default NotFound;
